
export class FormularioSolicitudCambiarBeneficiarios {
    clienteId?: number;
    titular!: string;
    titulo!: string;
	texto!: string;
	firma!: string;
    beneficiarios!: string;
}
